module.exports = __webpack_public_path__ + "static/media/avatar-4.16f71889.svg";